<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-card color="transparent" flat>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title class="font-weight-bold"
          >{{ $t('EPDModelSettings') }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          exact
          class="mr-2"
          @click="getModelSetting"
          >{{ $t("cancel") }}</v-btn
        >
        <v-btn color="primary" @click="updateModelSetting">{{
          $t("save")
        }}</v-btn>
      </v-toolbar>

      <v-card color="transparent" flat>
        <v-row no-gutters class="mb-1">
          <v-col cols="12" md="6">
            <v-card class="v-card__body v-sheet--outlined mt-0">
              <v-row no-gutters>
                <v-col cols="10">
                  <h4 class="black--text pb-6">{{ texts.resetMode.title }}</h4>
                </v-col>
                <v-col cols="2">
                  <v-switch
                    class="reset-switch-end"
                    name="overrideResetDuration"
                    v-model="modelSetting.overrideResetDuration"
                    color="success"
                    inset
                  ></v-switch>
                </v-col>
              </v-row>
              <hr class="grey-hr" />
              <v-row class="mt-1">
                <v-col cols="12" md="6" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{ texts.resetMode.progenyWeightingFactor.label }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.resetMode.progenyWeightingFactor.description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="progenyWeightingFactor"
                          type="number"
                          v-model="modelSetting.progenyWeightingFactor"
                          :rules="[rules.isRatio, rules.required]"
                          placeholder="Enter Number"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{ texts.resetMode.resetDuration.label }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.resetMode.resetDuration.description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="resetDuration"
                          type="number"
                          v-model="modelSetting.resetDuration"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Days"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card class="v-card__body v-sheet--outlined mt-0">
              <h4 class="black--text pb-6">
                {{ texts.maintenanceMode.title }}
              </h4>
              <hr class="grey-hr" />
              <v-row class="mt-1">
                <v-col cols="12" md="6" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{
                            texts.maintenanceMode.ancestorsWeightFactor.label
                          }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.maintenanceMode.ancestorsWeightFactor
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="ancestorsWeightFactor"
                          type="number"
                          v-model="modelSetting.ancestorsWeightingFactor"
                          :rules="[rules.isRatio, rules.required]"
                          placeholder="Enter Number"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters class="mb-1">
          <v-col cols="12">
            <v-card class="v-card__body v-sheet--outlined mt-0">
              <h4 class="black--text pb-6">{{ texts.epdSettings.title }}</h4>
              <hr class="grey-hr" />
              <v-row class="mt-1">
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{ texts.epdSettings.minAnimalsCg.label }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.epdSettings.minAnimalsCg.description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="minAnimalsCg"
                          type="number"
                          v-model="modelSetting.minAnimalsCg"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Animals"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{
                            texts.epdSettings.criticalProgenyPopulation.label
                          }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.epdSettings.criticalProgenyPopulation
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="criticalProgenyPopulation"
                          type="number"
                          v-model="modelSetting.criticalProgenyPopulation"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Animals"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{
                            texts.epdSettings.criticalAncestorPopulation.label
                          }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.epdSettings.criticalAncestorPopulation
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="criticalAncestorPopulation"
                          type="number"
                          v-model="modelSetting.criticalAncestorPopulation"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters class="mb-1">
          <v-col cols="12">
            <v-card class="v-card__body v-sheet--outlined mt-0">
              <h4 class="black--text pb-6">{{ texts.birthWeight.title }}</h4>
              <hr class="grey-hr" />
              <v-row class="mt-1">
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{ texts.birthWeight.bCriticalPopulationCg.label }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.birthWeight.bCriticalPopulationCg
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="bCriticalPopulationCg"
                          type="number"
                          v-model="modelSetting.bCriticalPopulationCg"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Animals"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{ texts.birthWeight.bCriticalAvgPopulationCg.label }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.birthWeight.bCriticalAvgPopulationCg
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="bCriticalAvgPopulationCg"
                          type="number"
                          v-model="modelSetting.bCriticalPopulationCg"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Animals"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters class="mb-1">
          <v-col cols="12">
            <v-card class="v-card__body v-sheet--outlined mt-0">
              <h4 class="black--text pb-6">{{ texts.weaningWeight.title }}</h4>
              <hr class="grey-hr" />
              <v-row class="mt-1">
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{ texts.weaningWeight.wCriticalPopulationCg.label }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.weaningWeight.wCriticalPopulationCg
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="wCriticalPopulationCg"
                          type="number"
                          v-model="modelSetting.wCriticalPopulationCg"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Animals"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{
                            texts.weaningWeight.wCriticalAvgPopulationCg.label
                          }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.weaningWeight.wCriticalAvgPopulationCg
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="wCriticalAvgPopulationCg"
                          type="number"
                          v-model="modelSetting.wCriticalAvgPopulationCg"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Animals"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters class="mb-1">
          <v-col cols="12">
            <v-card class="v-card__body v-sheet--outlined mt-0">
              <h4 class="black--text pb-6">{{ texts.yearlingWeight.title }}</h4>
              <hr class="grey-hr" />
              <v-row class="mt-1">
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{ texts.yearlingWeight.yCriticalPopulationCg.label }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.yearlingWeight.yCriticalPopulationCg
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="yCriticalPopulationCg"
                          type="number"
                          v-model="modelSetting.yCriticalPopulationCg"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Animals"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{
                            texts.yearlingWeight.yCriticalAvgPopulationCg.label
                          }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.yearlingWeight.yCriticalAvgPopulationCg
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="yCriticalAvgPopulationCg"
                          type="number"
                          v-model="modelSetting.yCriticalAvgPopulationCg"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Animals"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters class="mb-1">
          <v-col cols="12">
            <v-card class="v-card__body v-sheet--outlined mt-0">
              <h4 class="black--text pb-6">{{ texts.carcassWeight.title }}</h4>
              <hr class="grey-hr" />
              <v-row class="mt-1">
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{ texts.carcassWeight.cCriticalPopulationCg.label }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              texts.carcassWeight.cCriticalPopulationCg
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="cCriticalPopulationCg"
                          type="number"
                          v-model="modelSetting.cCriticalPopulationCg"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Animals"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="4" class="p-abs-0">
                  <v-list three-line class="p-0">
                    <v-list-item class="p-0">
                      <v-list-item-content>
                        <v-list-item-subtitle class="mb-2">
                          {{
                            texts.carcassWeight.cCriticalAvgPopulationCg.label
                          }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span style="max-width: 100px">{{
                              texts.carcassWeight.cCriticalAvgPopulationCg
                                .description
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-text-field
                          name="cCriticalAvgPopulationCg"
                          type="number"
                          v-model="modelSetting.cCriticalAvgPopulationCg"
                          :rules="[rules.noNegative, rules.required]"
                          placeholder="Enter Number of Animals"
                          outlined
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { userModelSetting } from "@/graphql/Users.gql";
import gql from "graphql-tag";

export default {
  name: "EPDModelSettings",
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("geneticsAndBreeding.geneticsAndBreeding"),
          disabled: false,
          link: true,
          exact: true,
          to: { name: "Genetics" },
        },
        {
          text: this.$t("EPDModelSettings"),
          disabled: true,
        },
      ],
      modelSetting: {
        overrideResetDuration: false,
      },
      rules: {
        required: value => value !== "" || "Value cannot be empty!",
        noNegative: value => Number(value) >= 0 || "Value cannot be negative!",
        isRatio: value =>
          (Number(value) >= 0 && Number(value) <= 1) ||
          "Value should be between 0 and 1",
      },
      texts: {
        resetMode: {
          title: this.$t('modelSettings.forResetMode'),
          progenyWeightingFactor: {
            label: this.$t('modelSettings.progenyWeightingFactor'),
            description:
              this.$t('modelSettings.progenyDescripion')
          },
          resetDuration: {
            label: this.$t('modelSettings.resetDuration'),
            description: this.$t('modelSettings.resetDurationDescripion'),
          },
        },
        maintenanceMode: {
          title: this.$t('modelSettings.forMaintenanceMode'),
          ancestorsWeightFactor: {
            label: this.$t('modelSettings.ancestorsWeightFactor'),
            description: this.$t('modelSettings.maintenanceModeDesc'),
          },
        },
        epdSettings: {
          title: this.$t('modelSettings.epdSettingsT'),
          minAnimalsCg: {
            label: this.$t('modelSettings.epdSettingsL'),
            description: this.$t('modelSettings.epdSettingsD'),
          },
          criticalProgenyPopulation: {
            label: this.$t('modelSettings.criticalProgenyL'),
            description: this.$t('modelSettings.criticalProgenyD'),
          },
          criticalAncestorPopulation: {
            label: this.$t('modelSettings.criticalAncestorL'),
            description: this.$t('modelSettings.criticalAncestorD'),
          },
        },
        birthWeight: {
          title: this.$t('modelSettings.birthWeightT'),
          bCriticalPopulationCg: {
            label: this.$t('modelSettings.criticalPopulationL'),
            description: this.$t('modelSettings.criticalPopulationD'),
          },
          bCriticalAvgPopulationCg: {
            label: this.$t('modelSettings.criticalAvgPopulationL'),
            description: this.$t('modelSettings.criticalAvgPopulationD'),
          },
        },
        weaningWeight: {
          title: this.$t('modelSettings.weaningWeightT'),
          wCriticalPopulationCg: {
            label: this.$t('modelSettings.criticalPopulationL'),
            description:
              "Minimum average number of animals per Weaning weight CG necessary to achieve  Average CG Accuracy (ACG3) above 50%",
          },
          wCriticalAvgPopulationCg: {
            label: this.$t('modelSettings.criticalAvgPopulationL'),
            description: this.$t('modelSettings.wCriticalDesc'),
          },
        },
        yearlingWeight: {
          title: this.$t('modelSettings.yearlingWeightT'),
          yCriticalPopulationCg: {
            label: this.$t('modelSettings.criticalPopulationL'),
            description: this.$t('modelSettings.yearlingWeightD1'),
          },
          yCriticalAvgPopulationCg: {
            label: this.$t('modelSettings.criticalAvgPopulationL'),
            description: this.$t('modelSettings.yearlingWeightD2'),
          },
        },
        carcassWeight: {
          title: this.$t('modelSettings.carcassWeightT'),
          cCriticalPopulationCg: {
            label: this.$t('modelSettings.criticalPopulationL'),
            description: this.$t('modelSettings.carcassWeightD1'),
          },
          cCriticalAvgPopulationCg: {
            label: this.$t('modelSettings.criticalAvgPopulationL'),
            description: this.$t('modelSettings.carcassWeightD2'),
          },
        },
      },
    };
  },
  methods: {
    // async getModelSetting() {
    //   const res = await EPDsettingsService.getEPDModelSettings();
    //   if (res.data.success) {
    //     this.modelSetting = res.data.data;
    //   } else {
    //     this.$notify({
    //       title: "Error fetching model settings",
    //       text: res.data.message,
    //       type: "error",
    //     });
    //   }
    // },
    async updateModelSetting() {
      // Object.keys(this.modelSetting).forEach(field => {
      //   this.modelSetting[field] = Number(this.modelSetting[field]);
      // });

      // const res = await EPDsettingsService.updateEPDModelSettings({
      //   epdModelSetting: this.modelSetting,
      // });

      // if (res.data.success) {
      //   this.modelSetting = res.data.data;
      //   this.$notify({
      //     title: "Success",
      //     text: res.data.message,
      //     type: "success",
      //   });
      // } else {
      //   this.$notify({
      //     title: "Error",
      //     text: res.data.message,
      //     type: "error",
      //   });
      // }

      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: CreateModelSettingInput!) {
              createOrUpdateModelSetting(createModelSettingInput: $data) {
                userId
              }
            }
          `,
          variables: {
            data: {
              criticalProgenyPopulation:
                +this.modelSetting.criticalProgenyPopulation,
              criticalAncestorPopulation:
                +this.modelSetting.criticalAncestorPopulation,
              bCriticalPopulationCg: +this.modelSetting.bCriticalPopulationCg,
              wCriticalPopulationCg: +this.modelSetting.wCriticalPopulationCg,
              yCriticalPopulationCg: +this.modelSetting.yCriticalPopulationCg,
              cCriticalPopulationCg: +this.modelSetting.cCriticalPopulationCg,
              bCriticalAvgPopulationCg:
                +this.modelSetting.bCriticalAvgPopulationCg,
              wCriticalAvgPopulationCg:
                +this.modelSetting.wCriticalAvgPopulationCg,
              yCriticalAvgPopulationCg:
                +this.modelSetting.yCriticalAvgPopulationCg,
              cCriticalAvgPopulationCg:
                +this.modelSetting.cCriticalAvgPopulationCg,
              weightProgenyCg: +this.modelSetting.weightProgenyCg,
              progenyWeightingFactor: +this.modelSetting.progenyWeightingFactor,
              weightAncestorCg: +this.modelSetting.weightAncestorCg,
              ancestorsWeightingFactor:
                +this.modelSetting.ancestorsWeightingFactor,
              resetDuration: +this.modelSetting.resetDuration,
              overrideResetDuration: this.modelSetting.overrideResetDuration,
              minAnimalsCg: +this.modelSetting.minAnimalsCg,
            },
          },
        })
        .then(async res => {
          console.log(res);
          if (
            res.data.createOrUpdateModelSetting &&
            res.data.createOrUpdateModelSetting.userId
          ) {
            this.$notify({
              title: "Updated",
              text: res.message,
              type: "success",
            });
          }
        })
        .catch(async error => {
          console.log(error);
          this.$notify({
            title: "Error",
            text: error.message,
            type: "error",
          });
          this.stopLoading();
        });
    },
  },
  apollo: {
    modelSetting: {
      query: userModelSetting,
      update: data => data?.userModelSetting,
    },
  },
  async created() {
    await this.$apollo.queries.modelSetting.refetch();
  },
};
</script>
<style scoped>
.p-abs-0 {
  padding: 0 !important;
}

.reset-switch-end {
  padding-top: 0;
  margin-top: 0;
}

/* Using Deep Selectors */
.reset-switch-end >>> .v-input__slot {
  justify-content: flex-end !important;
}

.reset-switch-end >>> .v-input--selection-controls__input {
  margin-right: 0 !important;
}

.v-card__body {
  background-color: #ffffff;
  padding: 24px;
  margin: 16px;
}

.grey-hr {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: none;
}

.input-label {
  color: #1e1e1e;
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
}

.input-label i {
  font-size: 20px;
  margin-left: 8px;
}

.bottom-banner {
  margin-top: 60px;
  background-color: #fff7ec;
  border: 1px solid #ffb443;
  border-radius: 5px;
  padding: 18px 26px;
}

.note-banner {
  margin-top: 10px;
  background-color: #fff7ec;
  border: 1px solid #ffb443;
  border-radius: 5px;
  padding: 18px 26px;
}
.bottom-banner .note-banner strong {
  font-weight: 600;
  color: #1e1e1e;
}
</style>
